import ApiService from "../api";

export default class MotoristaService extends ApiService {

    constructor() {
        super('/api/drivers');
    }

    findById(id) {
        return this.get(`/${id}`);
    }


    findByCode(code) {
        return this.get(`/code/${code}`);
    }

    findAllByBranch(id) {
        return this.get(`/branch/${id}`);
    }

    findAll(filter, pageSize, page) {
        let params = `?size=${pageSize}&page=${page}`

        if (filter.name) {
            params = `${params}&name=${filter.name}`
        }

        if (filter.id) {
            params = `${params}&id=${filter.id}`
        }

        if (filter.branchId) {
            params = `${params}&branchId=${filter.branchId}`
        }

        if (filter.branchCode) {
            params = `${params}&branchCode=${filter.branchCode}`
        }

        return this.get(`${params}`,); // suporte a paginação e filtro
    }

    create(client) {
        return this.post('/', client);
    }

    update(id, client) {
        return this.put(`/${id}`, client);
    }

    del(id) {
        return this.delete(`/${id}`);
    }

    importFileClient(branchId, atualiza, formData) {
        return this.post(`/import-clients/branch/${branchId}/${atualiza}`, formData);
    }
}


